import Loading from "@/components/Loading"

Loading.install = (Vue, options) => {
  Vue.prototype.$loading = new (Vue.extend(Loading))({ propsData: options })
  Vue.loading = Vue.prototype.$loading
}

export default Loading
